<form class="tw-flex tw-flex-col tw-gap-4" [formGroup]="formGroup">
  <app-input
    [label]="'symbolNameCode' | i18n"
    [placeholder]="'enterSymbolNameCode' | i18n"
    [isRequired]="true"
    [manualTouched]="this.formGroup.controls.name.touched"
    formControlName="name"
    class="tw-w-full"
  >
  </app-input>
  <app-dropdown-select
    [label]="'symbolGroup' | i18n"
    [options]="groupOptions"
    [selectedOption]="formGroup.get('group')?.value"
    [detachPanel]="true"
    [sort]="'date'"
    (optionSelected)="onInput($event, 'group')"
  ></app-dropdown-select>
  <div class="border-bottom-gray tw-pb-4"></div>
  @if (isEodhdInstalled()) {
    <div class="tw-flex tw-flex-col tw-gap-3">
      <!-- Find Price / Manually Enter Price segmented toggle (sliding thumb) -->
      <div
        class="tw-relative tw-flex tw-h-12 tw-w-full tw-items-center tw-rounded-2xl tw-bg-dt-surface-page tw-p-1"
      >
        <div
          class="tw-pointer-events-none tw-absolute tw-left-1 tw-top-1 tw-bottom-1 tw-w-[calc(50%-4px)] tw-rounded-2xl tw-bg-color-surface-elevated border-gradient-neuomorphic tw-shadow-neuomorphic-subtle-minimal tw-transition-transform tw-duration-300 tw-ease-out"
          [style.transform]="'translateX(' + activeTabIndex() * 100 + '%)'"
        ></div>
        @for (option of menu().options; track option.value) {
          <button
            type="button"
            (click)="currentTab.set(option.value)"
            class="tw-relative tw-z-10 tw-flex tw-h-full tw-flex-1 tw-cursor-pointer tw-items-center tw-justify-center tw-border-0 tw-bg-transparent"
          >
            <span
              class="tw-text-[14px] tw-font-medium tw-tracking-[0.005em] tw-transition-colors"
              [ngClass]="
                currentTab() === option.value
                  ? 'tw-text-dt-text-action'
                  : 'tw-text-dt-text-secondary'
              "
            >
              {{ option.displayValue }}
            </span>
          </button>
        }
      </div>
      @if (isFreeSubscription()) {
        <app-premium-callout></app-premium-callout>
      }
    </div>
  }
  @if (isFindPrice()) {
    <app-input
      [label]="('findOn' | i18n) + ' ' + selectedPlugin.name"
      [placeholder]="'searchByEnteringSymbolCompanyName' | i18n"
      [isRequired]="true"
      [isDisabled]="isFreeSubscription()"
      (outputValue)="onSearchInputChange($event, formGroup.get('date').value)"
    >
    </app-input>
  }
  <!-- Date picker: neumorphic trigger + app-calendar (single date) overlay -->
  <div class="tw-flex tw-w-full tw-flex-col tw-gap-1">
    <span class="tw-text-[13px] sm:tw-text-[12px] tw-font-bold tw-text-dt-text-tertiary">{{
      "asOnDate" | i18n
    }}</span>
    <app-date-field
      [displayText]="formGroup.get('date')?.value"
      [dateFilter]="dateFilter"
      [isDisabled]="isFreeSubscription()"
      [overlayWidth]="350"
      (dateChange)="onDatePicked($event)"
    ></app-date-field>
  </div>
  <div class="tw-flex tw-gap-4">
    <app-input
      [label]="'price' | i18n"
      [isRequired]="true"
      [type]="'number'"
      [isDisabled]="isFindPrice()"
      [manualTouched]="this.formGroup.controls.price.touched"
      formControlName="price"
      [value]="isFindPrice() ? searchedSymbol()?.rate : ''"
      class="tw-w-full"
    >
    </app-input>
    <app-currencies
      class="tw-w-full tw-font-neutral-800 tw-mb-3"
      (onSelectCurrency)="onInput($event, 'currency')"
      [label]="'Currency'"
      [disabled]="isFindPrice()"
      [defaultCurrency]="defaultCurrency()"
      [detachPanel]="true"
    ></app-currencies>
  </div>
  <div class="tw-flex tw-w-full tw-items-center tw-justify-end tw-gap-4 sm:tw-flex-col">
    <button
      type="button"
      (click)="closeDialog && closeDialog()"
      class="tw-flex tw-h-[48px] tw-shrink-0 tw-items-center tw-justify-center tw-px-8 tw-rounded-[60px]"
    >
      <span
        class="tw-text-[20px] sm:tw-text-[18px] tw-font-medium tw-tracking-[0.005em] tw-leading-[135%] tw-text-dt-text-headings"
        >{{ "cancel" | i18n }}</span
      >
    </button>
    <button
      type="button"
      (click)="submit()"
      [attr.aria-busy]="submitting || null"
      [disabled]="isFreeSubscription()"
      class="tw-flex tw-w-[300px] md:tw-w-full tw-items-center tw-justify-center tw-rounded-[50px] tw-bg-dt-surface-on-action tw-px-6 tw-py-4 tw-shadow-elevation-cta-glow disabled:tw-opacity-50"
    >
      <span
        class="tw-text-[20px] sm:tw-text-[18px] tw-font-medium tw-tracking-[0.005em] tw-leading-[135%] tw-text-dt-slate-0 tw-whitespace-nowrap"
        >{{ "save" | i18n }}</span
      >
    </button>
  </div>
</form>
